import { AlertDialogPrimaryLayout } from "../../layouts/alert-dialog-primary-layout";
import { Conflict } from "src/components/atoms";
import type { CompositionProp } from "src/utils";

type AlertDialogConfirmationLayoutProps = React.PropsWithChildren<{
    icon?: React.ReactNode;
    title?: CompositionProp;
    onConfirm: () => void;
    confirmButtonText?: string;
    confirmDisabled?: boolean;
    onCancel?: () => void;
    cancelButtonText?: string;
}>;

const AlertDialogConfirmation: React.FC<AlertDialogConfirmationLayoutProps> = ({
    title,
    icon = <Conflict className="h-7 w-7 text-error" />,
    onConfirm,
    confirmButtonText,
    confirmDisabled,
    onCancel,
    cancelButtonText,
    children
}) => {
    return (
        <AlertDialogPrimaryLayout 
          title={title}
          icon={icon} 
          primaryButton={confirmButtonText} 
          secondaryButton={cancelButtonText}
          onPrimaryAction={onConfirm}
          primaryButtonProps={{ disabled: confirmDisabled }}
          onSecondaryAction={onCancel}
        >
            {children}
        </AlertDialogPrimaryLayout>
    );
};

export { AlertDialogConfirmation };
